import { Decrypt, Encrypt } from "../Cryptography/Crypto";

export const SetEncryptedMemberIdToLocalStorage = (MemberId) => {
  const encryptedMemberId = Encrypt(MemberId);
  localStorage.setItem("MemberId", encryptedMemberId);
};

export const GetDecryptedMemberIdFromLocalStorage = () => {
  const encyptedMemberId = localStorage.getItem("MemberId");
  let memberId = "";
  if (encyptedMemberId) {
    memberId = Decrypt(encyptedMemberId);
  }

  return memberId;
};

export const DeleteMemberIdFromLocalStorage = () => {
  localStorage.removeItem("MemberId");
};
